import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const COMPANY_JOBS_PER_PAGE = 20;

export const useGetCompanyJobs = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getCompanyJobs = (
    slug: string,
    page: number = 1,
    limit: number = COMPANY_JOBS_PER_PAGE
  ) => {
    send({}, `/api/v1/companies/${slug}/jobs?page=${page}&limit=${limit}`).then();
  };

  return {
    getCompanyJobs,
    data,
    isLoading,
    error,
  };
};
